import { COLORS } from "layouts/ThemeProvider/palette";
import palette from "layouts/ThemeProvider/palette";

const buttonDefault = {
  height: 40,
  fontSize: 15,
  padding: [0, 30],
  borderWidth: 1.5,
  borderRadius: 20,
  textTransform: "none",
};

export default {
  MuiButton: {
    outlinedPrimary: {
      ...buttonDefault,
      borderColor: COLORS.havelockBlue,
      color: COLORS.havelockBlue,
      "&:hover": {
        "@media (hover: hover)": {
          backgroundColor: COLORS.havelockBlue,
          color: "#fff",
        },
      },
    },
    outlinedSecondary: {
      ...buttonDefault,
      border: [1, "solid", COLORS.turquoise],
      color: COLORS.turquoise,
      "&:hover": {
        "@media (hover: hover)": {
          backgroundColor: COLORS.turquoise,
          color: "#fff",
        },
      },
    },
    colorInherit: {
      ...buttonDefault,
      transition: "transform 0.6s cubic-bezier(0.22, 1, 0.36, 1)",
      backgroundImage: palette.baseGradient,
      color: "#fff",
      "&:hover": {
        "@media (hover: hover)": {
          backgroundImage: palette.baseGradient,
          color: "#fff",
        },
      },
    },
    contained: {
      ...buttonDefault,
      backgroundColor: "#fff",
      color: COLORS.havelockBlue,
      transition: "transform 0.6s cubic-bezier(0.22, 1, 0.36, 1)",
      "&:hover": {
        transform: "scale(1.1)",
        backgroundColor: "#fff",
        "@media (hover: hover)": {
          transform: "scale(1.1)",
        },
      },
    },
    containedPrimary: {
      ...buttonDefault,
      backgroundColor: COLORS.havelockBlue,
      color: "#fff",
      "&:hover": {
        "@media (hover: hover)": {
          backgroundColor: COLORS.havelockBlue,
          color: "#fff",
        },
      },
    },
    containedSecondary: {
      ...buttonDefault,
      backgroundColor: COLORS.turquoise,
      borderColor: COLORS.turquoise,
      color: "#fff",
      "&:hover": {
        "@media (hover: hover)": {
          backgroundColor: COLORS.turquoise,
          borderColor: COLORS.turquoise,
          color: "#fff",
        },
      },
    },
    sizeLarge: {
      height: 60,
      borderRadius: 30,
      borderWidth: 2,
      fontSize: 20,
      padding: [0, 34],
    },
  },
};
